import { render, staticRenderFns } from "./counter.component.vue?vue&type=template&id=57972d13&scoped=true"
import script from "./counter.component.vue?vue&type=script&lang=js"
export * from "./counter.component.vue?vue&type=script&lang=js"
import style0 from "./counter.component.vue?vue&type=style&index=0&id=57972d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57972d13",
  null
  
)

export default component.exports